import { render, staticRenderFns } from "./stockLossList.vue?vue&type=template&id=57319bd4&scoped=true"
import script from "./stockLossList.vue?vue&type=script&lang=js"
export * from "./stockLossList.vue?vue&type=script&lang=js"
import style0 from "./stockLossList.vue?vue&type=style&index=0&id=57319bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57319bd4",
  null
  
)

export default component.exports